var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12453 11.668C8.12421 11.7613 8.14482 11.8536 8.18483 11.938C8.22485 12.0223 8.28326 12.0967 8.35578 12.1555L12.1058 15.1742C12.2176 15.2662 12.3579 15.3164 12.5026 15.3164C12.6474 15.3164 12.7877 15.2662 12.8995 15.1742L16.6495 12.0492C16.7772 11.9431 16.8574 11.7907 16.8727 11.6254C16.8879 11.4602 16.8369 11.2956 16.7308 11.168C16.6247 11.0403 16.4722 10.9601 16.307 10.9448C16.1417 10.9296 15.9772 10.9806 15.8495 11.0867L12.4995 13.8805L9.14953 11.1805C9.05778 11.1041 8.94607 11.0555 8.8276 11.0406C8.70914 11.0257 8.58887 11.045 8.48104 11.0963C8.37321 11.1475 8.28233 11.2286 8.21915 11.33C8.15597 11.4313 8.12313 11.5486 8.12453 11.668Z",
    fill: "#433501",
    fillOpacity: 0.88
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.eaad8fe6.svg";
export { ForwardRef as ReactComponent };